import { Toaster } from '@gravity-ui/uikit';

const toaster = new Toaster();

export { toaster };
